/* eslint-disable prettier/prettier */

/**
 * Здесь описываются входные и выходные переменные
 * При заполнении формы в браузере в поля value
 * у входных переменных записываются значения из формы
 */
export default {
    // входные переменные
    inputs: [{
            name: "Высота",
            value: 50,
            fuzzyAreas: [{
                    name: "Столешница очень низко",
                    ranges: [0, 7, 17],
                },
                {
                    name: "Ниже стула",
                    ranges: [12, 20, 38],
                },
                {
                    name: "Как стул",
                    ranges: [20, 30, 50, 88],
                },
                {
                    name: "Как стол",
                    ranges: [70, 80, 110, 150],
                },
                {
                    name: "С рост человека и выше",
                    ranges: [120, 160, 200],
                }
            ]
        },
        {
            name: "Ширина",
            value: 50,
            fuzzyAreas: [{
                    name: "Поместится телефон боком",
                    ranges: [0, 8, 35],
                },
                {
                    name: "Поместится раскрытая тетрадь",
                    ranges: [25, 38, 68],
                },
                {
                    name: "Поместится 2 раскрытые тетради",
                    ranges: [40, 60, 75, 140],
                },
                {
                    name: "Можно растянуть руки в разные стороны",
                    ranges: [100, 130, 160, 200],
                }
            ]
        },
        {
            name: "Материал",
            value: 50,
            fuzzyAreas: [{
                    name: "Палки и листья",
                    ranges: [0, 3, 8],
                },
                {
                    name: "Картон",
                    ranges: [5, 15, 34],
                },
                {
                    name: "Фанера",
                    ranges: [18, 45, 67],
                },
                {
                    name: "Дерево/дсп",
                    ranges: [50, 55, 75, 92],
                },
                {
                    name: "Камень",
                    ranges: [80, 95, 100, 100],
                }
            ]
        },
        {
            name: "Место для протягивания ног",
            value: 50,
            fuzzyAreas: [{
                    name: "Для детской ступни",
                    ranges: [0, 12, 15, 24],
                },
                {
                    name: "Для большой ступни",
                    ranges: [20, 28, 42],
                },
                {
                    name: "Норм, если согнуть ноги в коленях",
                    ranges: [30, 40, 50, 72],
                },
                {
                    name: "Можно расправить ноги среднего роста человеку",
                    ranges: [60, 85, 130],
                },
                {
                    name: "Можно расправить ноги высокого роста человеку",
                    ranges: [90, 110, 150, 150],
                }
            ]
        }
    ],
    // выходная переменная
    outputs: [{
        name: "Стоит ли сидеть за столом",
        fuzzyAreas: [{
                name: "Это не похоже на стол",
                ranges: [0, 5, 10],
            },
            {
                name: "Лучше не садиться, но если очень хочется...",
                ranges: [7, 14, 23],
            },
            {
                name: "Для аккуратного ребенка",
                ranges: [18, 28, 35],
            },
            {
                name: "Для подростка",
                ranges: [30, 40, 50, 60],
            },
            {
                name: "Для взрослого",
                ranges: [53, 65, 80, 85],
            },
            {
                name: "Для компании друзей",
                ranges: [78, 92, 100, 100],
            }
        ]
    }]
};